import { useState } from 'react'
import { SeeMore, ItemPreview } from '@/components'
import { ItemData } from '../ItemPreview'
import { BaseProps } from '@/components/types'

function ItemPreviewList ( props: ItemPreviewListProps ) {
    const {
        itemList, defaultShowItemCount = 10, marginTop = '8px', marginBottom = '8px',
        onClickImage,
        ...rest
    } = props
    const [ showItemCount, setShowItemCount ] = useState( defaultShowItemCount )

    return (
        <>
            <div style={ { display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between'} }>
                {
                    itemList && itemList.map( ( data, idx ) => {
                        return (
                            <ItemPreview
                                { ...rest }
                                key={ `${ data.propertyId }${ idx }` }
                                data={ data }
                                marginTop={ marginTop }
                                marginBottom={ marginBottom }
                                onClickImage={ () =>{
                                    onClickImage && onClickImage( data )
                                } }
                            />
                        )
                    } ).slice( 0, showItemCount > itemList.length ? itemList.length : showItemCount )
                }
            </div>
            <SeeMore
                defaultShowCount={ defaultShowItemCount }
                setShowCount={ setShowItemCount }
                totalList={ itemList }
                marginTop={ marginTop }
                marginBottom={ marginBottom }
            />
        </>
    )
}

export default ItemPreviewList

export interface ItemPreviewListProps extends BaseProps {
    itemList: ItemData[]
    defaultShowItemCount?: number
    marginTop?: string | number
    marginBottom?: string | number
    onClickImage?: ( item: ItemData ) => void
}
